import { render, staticRenderFns } from "./TierPlanBox.vue?vue&type=template&id=ac1ad426&"
import script from "./TierPlanBox.vue?vue&type=script&lang=js&"
export * from "./TierPlanBox.vue?vue&type=script&lang=js&"
import style0 from "./TierPlanBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports